import type { NewsItem } from '@features/parkingMap/types';

const XML_MIME_TYPE = 'application/xml';
const PARSER_ERROR_TAG = 'parsererror';

const readChildText = (element: Element, tagName: string): string | undefined =>
  element.getElementsByTagName(tagName)[0]?.textContent?.trim() || undefined;

const toNewsItem = (itemElement: Element): NewsItem | undefined => {
  const title = readChildText(itemElement, 'title');
  const url = readChildText(itemElement, 'link');
  const guid = readChildText(itemElement, 'guid') ?? url;
  const publishedAt = new Date(readChildText(itemElement, 'pubDate') ?? '');

  if (!title || !url || !guid || Number.isNaN(publishedAt.getTime())) return undefined;

  return { guid, title, url, publishedAt };
};

// Returns the valid items of an RSS 2.0 feed; items missing a title, link or
// parsable pubDate are skipped. Malformed XML yields an empty list.
export const parseNewsFeed = (xml: string): NewsItem[] => {
  const document = new DOMParser().parseFromString(xml, XML_MIME_TYPE);
  if (document.getElementsByTagName(PARSER_ERROR_TAG).length > 0) return [];

  return Array.from(document.getElementsByTagName('item'))
    .map(toNewsItem)
    .filter((newsItem): newsItem is NewsItem => newsItem !== undefined);
};
